// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import DriverForm from '../driver-form';

// ----------------------------------------------------------------------

export default function CreateDriverView() {
    const settings = useSettingsContext();

    return (
        <Container maxWidth={settings.themeStretch ? false : 'lg'}>
            <CustomBreadcrumbs
                heading="Register Driver"
                links={[
                    {
                        name: 'Dashboard',
                        href: paths.dashboard.driverReview.root,
                    },
                    {
                        name: 'Driver Guide',
                        href: paths.dashboard.user.driverGuide,
                    },
                    { name: 'Add Driver' },
                ]}
                sx={{
                    mb: { xs: 3, md: 5 },
                }}
            />

            <DriverForm  isEdit={false}/>

        </Container>
    );
}

